/**
 * IDs de las capas de resaltado del mapa (GraphicsLayer).
 * En un archivo propio para que ubigeo y KPI los compartan sin
 * dependencias circulares entre notifiers.
 */
export const SELECTED_UBIGEO_LAYER_ID = 'selected-ubigeo-layer';
export const KPI_HIGHLIGHT_LAYER_ID = 'kpi-highlight-layer';
/** Geometrías de elementos expuestos del "Ver detalle" agro (parcelas, productores…). */
export const KPI_EXPOSED_LAYER_ID = 'kpi-exposed-layer';
